import {
  ISiteFacet,
  ISiteTag,
} from "../../redux/api/site-classification/siteClassificationAPI";

export const SECTOR_KEY = "SECTOR";

export interface ILabelledSiteTag {
  facetId: string;
  facetName: string;
  labels: string[];
}

// Site responses carry siteTags beside the vendor's own fields; the shared plant interfaces in
// core do not declare it, so it is read here rather than on each of them.
export const siteTagsOf = (plant: unknown): ISiteTag[] =>
  ((plant as { siteTags?: ISiteTag[] } | undefined)?.siteTags ?? []).filter(
    (tag) => tag && tag.facetId,
  );

// The site's tags as names, in the organization's facet order. A tag whose facet or value is
// not in the list - kept from guests, say - is left out rather than shown as an id.
export const labelSiteTags = (
  facets: ISiteFacet[],
  siteTags: ISiteTag[],
): ILabelledSiteTag[] =>
  facets.flatMap((facet) => {
    const tag = siteTags.find((candidate) => candidate.facetId === facet.id);
    const labels = (tag?.valueIds ?? [])
      .map((valueId) => facet.values.find((value) => value.id === valueId))
      .filter((value) => value !== undefined)
      .map((value) => value!.label);

    return labels.length > 0
      ? [{ facetId: facet.id, facetName: facet.name, labels }]
      : [];
  });

// The site's sector, or undefined while it is unclassified.
export const sectorLabelOf = (
  facets: ISiteFacet[],
  siteTags: ISiteTag[],
): string | undefined => {
  const sector = facets.find((facet) => facet.standardKey === SECTOR_KEY);

  return sector
    ? labelSiteTags([sector], siteTags)[0]?.labels[0]
    : undefined;
};
